import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface WelcomeRedirectRouteProps {
  children: React.ReactNode;
}

const WelcomeRedirectRoute: React.FC<WelcomeRedirectRouteProps> = ({ children }) => {
  const { user, isAuthenticated, isInitializing, currentOrganization } = useAuth();

  if (isInitializing) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Verificar se o usuário precisa selecionar um plano
  const needsPlanSelection = !currentOrganization?.currentPlan || localStorage.getItem('needsPlanSelection') === 'true';
  if (needsPlanSelection) {
    return <Navigate to="/change-plan" replace state={{ forceSelection: true }} />;
  }

  // Check if user should be redirected to welcome page
  if (user?.shouldRedirectWelcome) {
    return <Navigate to="/welcome" replace />;
  }

  return <>{children}</>;
};

export default WelcomeRedirectRoute;
